import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { usersRef, getUserRef, serverTimestamp } from '../../firebase/collections';
import AdminLayout from '../../Components/Admin/AdminLayout';

function AdminUsers() {
  const { t } = useTranslation();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [statusFilter, setStatusFilter] = useState('');

  useEffect(() => {
    let q = usersRef().limit(100);
    if (statusFilter) {
      q = usersRef().where('accountStatus', '==', statusFilter).limit(100);
    }
    q.get()
      .then((snap) => {
        setUsers(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
      })
      .finally(() => setLoading(false));
  }, [statusFilter]);

  const setAccountStatus = (userId, accountStatus) => {
    getUserRef(userId).update({ accountStatus, updatedAt: serverTimestamp() }).then(() => {
      setUsers((prev) => prev.map((u) => (u.id === userId ? { ...u, accountStatus } : u)));
    });
  };

  const toggleWhitelisted = (userId, currentVal) => {
    const whitelisted = !currentVal;
    getUserRef(userId).update({ whitelisted, updatedAt: serverTimestamp() }).then(() => {
      setUsers((prev) => prev.map((u) => (u.id === userId ? { ...u, whitelisted } : u)));
    });
  };

  return (
    <AdminLayout>
      <h1>{t('admin.users')}</h1>
      <div className="adminFilters">
        <label>{t('admin.accountStatus')}: </label>
        <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
          <option value="">{t('admin.all')}</option>
          <option value="active">{t('admin.active')}</option>
          <option value="suspended">{t('admin.suspended')}</option>
          <option value="banned">{t('admin.banned')}</option>
          <option value="deactivated">{t('admin.deactivated')}</option>
        </select>
      </div>
      {loading ? (
        <p>{t('admin.loading')}</p>
      ) : (
        <div className="adminTableWrap">
          <table className="adminTable">
            <thead>
              <tr>
                <th>{t('admin.id')}</th>
                <th>{t('admin.name')}</th>
                <th>{t('admin.email')}</th>
                <th>{t('admin.role')}</th>
                <th>{t('admin.account')}</th>
                <th>{t('admin.kyc')}</th>
                <th>{t('admin.trust')}</th>
                <th>{t('admin.whitelisted')}</th>
                <th>{t('admin.actions')}</th>
              </tr>
            </thead>
            <tbody>
              {users.map((u) => (
                <tr key={u.id}>
                  <td>{u.id}</td>
                  <td>{u.name}</td>
                  <td>{u.email}</td>
                  <td>{u.role || 'user'}</td>
                  <td>{u.accountStatus || 'active'}</td>
                  <td>{u.kycStatus || '—'}</td>
                  <td>{u.trustScore ?? '—'}</td>
                  <td>
                    <label className="adminToggle">
                      <input
                        type="checkbox"
                        checked={!!u.whitelisted}
                        onChange={() => toggleWhitelisted(u.id, u.whitelisted)}
                      />
                      <span className="adminToggleSlider" />
                    </label>
                  </td>
                  <td>
                    {(u.accountStatus === 'active' || !u.accountStatus) && (
                      <>
                        <button type="button" onClick={() => setAccountStatus(u.id, 'suspended')}>{t('admin.suspend')}</button>
                        <button type="button" onClick={() => setAccountStatus(u.id, 'banned')}>{t('admin.ban')}</button>
                      </>
                    )}
                    {u.accountStatus === 'suspended' && (
                      <button type="button" onClick={() => setAccountStatus(u.id, 'active')}>{t('admin.reactivate')}</button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </AdminLayout>
  );
}

export default AdminUsers;
